import "./BusinessTypeStep.css";

const providerTypes = [
  {
    id: "Home Kitchen",
    title: "Home Kitchen",
    subtitle: "Home Chef • Mess • Tiffin Service",
    icon: "🏠",
    recommended: true,
  },
  {
    id: "Restaurant",
    title: "Restaurant",
    subtitle: "Restaurants • Fine Dining",
    icon: "🍽",
  },
  {
    id: "Hotel",
    title: "Hotel",
    subtitle: "Hotels • Lodging with Food",
    icon: "🏨",
  },
  {
    id: "Bakery",
    title: "Bakery",
    subtitle: "Cakes • Pastries • Desserts",
    icon: "🧁",
  },
  {
    id: "Catering",
    title: "Catering",
    subtitle: "Marriage • Birthday • Events",
    icon: "🍱",
  },
  {
    id: "Provision Store",
    title: "Provision Store",
    subtitle: "Groceries • Daily Essentials",
    icon: "🛒",
  },
];

function BusinessTypeStep({
  providerData,
  setProviderData,
  nextStep,
}) {

  const selectProvider = (providerType) => {

    setProviderData({

      ...providerData,

      providerType,

    });

    // Move directly to Owner Details
    nextStep();

  };

  return (

    <div className="business-step">

      <h1>

        Become a Provider

      </h1>

      <p>

        Select the business category that best matches your business.

      </p>

      <div className="provider-grid">

        {

          providerTypes.map((item) => (

            <div

              key={item.id}

              className="provider-box"

              onClick={() => selectProvider(item.id)}

            >

              {

                item.recommended && (

                  <span className="recommended">

                    Recommended

                  </span>

                )

              }

              <div className="provider-icon">

                {item.icon}

              </div>

              <h2>

                {item.title}

              </h2>

              <p>

                {item.subtitle}

              </p>

            </div>

          ))

        }

      </div>

    </div>

  );

}

export default BusinessTypeStep;